<template>
	<div class="explain-solution">
		<div v-if="quiz.note.trim().length > 0" :is="explain_component(quiz.note)" class="note"></div>
		<div v-if="quiz.comments.filter(el => el.length > 0).length > 0">
			<transition-group name="slideUp" tag="ul" class="list-comments">
				<li
					v-for="(comment, i_comment) in quiz.comments"
					:is="explain_component(comment)"
					:key="hash(comment) + i_comment"></li>
				</transition-group>
			</div>
		<div v-if="quiz.explains.filter(el=>el.trim().length > 0).length > 0">
			<transition-group name="slideUp" tag="ul" class="list-explains">
				<li
					v-for="(explain, i_explain) in quiz.explains"
					:is="explain_component(explain)"
					:key="hash(explain) + i_explain"></li>
				</transition-group>
			</div>
		<div class="operations">
			<transition-group name="slideDown" tag="ul" class="list-operations">
				<li v-for="oper in operationsDisplayed" :class="['operation-block', {'style-none': strip_tags(oper.exp.trim()) == ''}]" :key="hash(oper.exp)">
					<div class="litteral" :is="explain_component(oper.exp)"></div>
					<div class="operation" v-if="oper.display !== false">
						<operation-component :operation="oper" :floating="oper.floating || oper.isFloat" :datas="{ operator:oper.operator, terms:evaluate(oper) }" :fract="oper.fract || oper.answerOperation.isFraction" :estimated="oper.estimated" :units="operation.units" />
						</div>
					</li>
				</transition-group>
			</div>
		<div class="solution" :is="solution_component"></div>
	</div>
</template>

<script>
	import OperationComponent from './operations/OperationComponent.vue';
	import BaseExerciseMixin from '../js/BaseExerciseMixin';
	import FractionComponent from './FractionComponent.vue';
	import Fnc from 'usefull-functions';
	export default {
		name: 'explain-solution',
		components: { OperationComponent },
		props: { quiz: Object },
		created() {
		},
		mixins:[BaseExerciseMixin],
		methods:{
		 	evaluate(operation) {
		 		let arr = [], op = operation.operator;
		 		arr = operation.operands.map( (element, index) =>{
		 		 	return (element instanceof Object && !element.isFraction) ? this.currentQuiz.calculate(element):element;
		 		});
		 		return arr;
		 	},
		 	operation(ref) {
		 		let res = this.quiz.operations.filter(el=>el.lbl == ref)[0];
		 		return res;
		 	},
		 	explain_component(explain) {
		 		return { template: Fnc.tag('div', explain),components:{ FractionComponent }, name:"explain" };
		 	},
		},
		computed:{
			solution_component() {
				return {
					template: this.tag('div', this.quiz.solution),
					components: { FractionComponent },
					name: "solution",
				};
			},
			operationsDisplayed(){
				return this.quiz.operations.filter(el => {
					return Fnc.strip_tags(el.exp).trim() !== '$$none$$';
				});
			}
		}
	};
</script>

<style lang="scss">
	.explain-solution{
		ol, ul{
		   padding-left: 20px;
		}
		.result{
			color: #e3342f;
		}
		.list-explains{}
		.litteral{}
		.operations{
			.list-operations{
				list-style: url('../assets/next-bold.svg');
				.operation-block{
					&.style-none{
						list-style-type: none;
						list-style: none;
					}
				}
				li{
				}
				.litteral{
					.expression{}
					.operation{
						margin: 1rem;
						display: inline-block;
					}
				}
				.operation{
					.result{
						font-weight: normal;
					}
				}
			}
		}
		.solution{
			padding-left: 0.5rem;
			color: #007800;
		}
		strong{
			font-weight: 700;
		}
	}
</style>